import React from 'react';
import '../css/FounderMessageDetail.css';

const FounderMessageDetail = () => {
  return (
    <section className="gfi-founder-detail-section">
      <div className="gfi-founder-detail-container">
        <div className="gfi-founder-detail-layout-grid">
          
          {/* ==========================================
              LEFT COLUMN: EXECUTIVE CARD FRAMEWORK 
             ========================================== */}
          <div className="gfi-f-left-profile-sidebar">
            <div className="gfi-f-profile-card">
              
              {/* Executive Image Frame matching image 12_2 */}
              <div className="gfi-f-image-canvas">
                <img 
                  src="https://images.unsplash.com/photo-1560250097-0b93528c311a?q=80&w=600&auto=format&fit=crop" 
                  alt="Mr. Manoranjan Kumar Singh" 
                  className="gfi-f-avatar" 
                />
              </div>

              {/* Identity Nodes */}
              <div className="gfi-f-identity-header">
                <h3 className="gfi-f-name">Mr. Rohit Sharma</h3>
                <p className="gfi-f-post-credentials">CertIOSH</p>
                <span className="gfi-f-badge-tag">FOUNDER & CEO</span>
              </div>

              {/* Academic & Professional Credentials Mini Box */}
              <div className="gfi-f-credentials-nested-box">
                <ul className="gfi-f-credentials-list">
                  <li><span className="gfi-cred-bullet">🎓</span> M.Sc, MBA</li>
                  <li><span className="gfi-cred-bullet">🔷</span> NEBOSH IGC/HSW</li>
                  <li><span className="gfi-cred-bullet">🏅</span> IDIP Qualified</li>
                  <li><span className="gfi-cred-bullet">👥</span> Member: IOSH & NSC India</li>
                </ul>
              </div>

            </div>
          </div>

          {/* ==========================================
              RIGHT COLUMN: MESSAGE STATEMENT CORE
             ========================================== */}
          <div className="gfi-f-right-message-content">
            
            <h2 className="gfi-f-main-section-heading">Vision for Professional Excellence</h2>
            
            {/* Premium Soft Blue Highlighted Quote Bracket Block */}
            <div className="gfi-f-quote-highlight-container">
              <div className="gfi-f-quote-thick-accent-bracket"></div>
              <p className="gfi-f-highlighted-quote-txt">
                "Education is not only about certificates; it is about building confidence, skills, and a better future."
              </p>
            </div>

            {/* Rich Text Core Paragraph Matrix */}
            <div className="gfi-f-narrative-rich-body">
              <h4 className="gfi-f-welcome-node">Welcome to GreenFiled Academy Pvt. Ltd.</h4>
              
              <p>
                When we started this institution, our vision was simple — to provide quality 
                professional education and help students build successful careers in Fire & Safety, 
                Industrial Safety, Health & Safety, and related industries.
              </p>

              <p>
                Today, industries are changing rapidly, and employers are looking for professionals 
                who not only have theoretical knowledge but also practical understanding, confidence, 
                and problem-solving skills. At Growth Academy, we focus on practical learning, 
                industry-oriented training, and real-world safety awareness so that our students are 
                prepared for professional challenges.
              </p>

              <p>
                We believe every student has unique talent and potential. Our responsibility is to guide, 
                support, and help them grow professionally. Through experienced trainers, practical 
                sessions, modern learning methods, and career guidance, we continuously work to 
                create a positive and professional learning environment.
              </p>

              <p>
                Our mission is not only to provide training but also to help students develop discipline, 
                leadership qualities, communication skills, and professional confidence that support 
                long-term career growth.
              </p>

              <p>
                Over the years, the trust and support of our students, parents, trainers, and industry 
                partners have motivated us to continuously improve and expand our educational 
                services. We remain committed to maintaining quality training standards and helping 
                students achieve their professional goals.
              </p>

              <p className="gfi-f-final-greeting-para">
                I sincerely thank everyone who has been part of the Growth Academy journey. I 
                welcome you to become a part of the Growth Academy family and move forward 
                toward a safer, more successful, and brighter future.
              </p>
            </div>

            {/* Bottom Elegant Line Divider & Signature Panel */}
            <hr className="gfi-f-bottom-horizontal-line" />
            
            <div className="gfi-f-signature-footer-panel">
              <div className="gfi-f-fountain-pen-badge">
                <span className="gfi-f-pen-glyph">✒️</span>
              </div>
              <div className="gfi-f-signature-meta-box">
                <h5 className="gfi-f-signature-name">Mr. Rohit Sharma</h5>
                <p className="gfi-f-signature-title">Founder & CEO, GIPS Pvt. Ltd.</p>
              </div>
            </div>

          </div>

        </div>
      </div>
    </section>
  );
};

export default FounderMessageDetail;